import moment from 'moment';
import range from 'lodash/range';

const getTimeDurations = (startTime, endTime, durationStep) => {
  const durationsRange = range(startTime, endTime, durationStep);
  return durationsRange.map(duration => ({
    value: duration,
    label: duration === 86400000 ? '24 h 00 m' : moment.utc(duration).format('H [h] mm [mm]'),
  }));
};

export default getTimeDurations;
